import "./Services.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import ExpertHandymanSolutionsForYourHome from "./sections/ExpertHandymanSolutionsForYourHome";
import Services from "./sections/Services";
import StrategicDefenseMethodology from "./sections/StrategicDefenseMethodology";
import ComprehensiveFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <VoltMainHeader />
      <ExpertHandymanSolutionsForYourHome />
      <Services />
      <StrategicDefenseMethodology />
      <ComprehensiveFooter />
    </div>;
}